<template>
  <div class="registrationBig" style="background: #f4f4f4">
    <!-- <div class="headerDiv">
      <div class="fh" @click="home"><van-icon name="arrow-left" /></div>
      <div style="font-weight: 600">报名结果页</div>
    </div> -->
    <div class="tipsSuccess" style="margin-top: 0.2rem">报名成功！</div>
    <div class="main">
      <div
        style="
          margin-top: 0.2rem;
          margin-bottom: 0.3rem;
          font-weight: 600;
          font-size: 0.3rem;
          text-align: center;
        "
      >
        请扫码添加微信好友，进行继续教育
      </div>
      <img
        style="width: 80%; display: block; margin: 0 auto"
        src="../../../assets/ewm.jpg"
      />
    </div>
    <!-- <div class="btn" @click="signUp" >确定</div> -->
  </div>
</template>

<script>
import { Icon } from "vant";
export default {
  components: {
    [Icon.name]: Icon,
  },
  data() {
    return {};
  },
  created() {},
  methods: {
    signUp() {
      this.$router.push({
        name: "RegistrationPage",
        query: {},
      });
    },
    home() {
      this.$router.push({
        name: "Registration",
        query: {},
      });
    },
    query() {
      this.$router.push({
        name: "ToQuery",
        query: {},
      });
    },
  },
};
</script>

<style scoped>
.registrationBig {
  overflow: hidden;
  height: 100%;
}
.tipsSuccess {
  line-height: 0.8rem;
  font-size: 0.3rem;
  font-weight: 800;
  text-align: center;
  color: #fa533d;
}
.headerDiv {
  position: relative;
  height: 0.7rem;
  text-align: center;
  line-height: 0.7rem;
  font-size: 0.26rem;
  border-bottom: 0.02rem solid #eeeeee;
}
.fh {
  position: absolute;
  left: 0.1rem;
  top: 50%;
  transform: translate(0, -50%);
}
.main {
  width: 91%;
  margin: 0 auto;
  font-size: 0.3rem;
  line-height: 0.52rem;
  font-weight: 400;
  background: #fff;
  padding: 3%;
  margin-top: 0.2rem;
  margin-bottom: 0.3rem;
}
.btn {
  width: 94%;
  height: 0.82rem;
  line-height: 0.82rem;
  background: #00ae7e;
  border-radius: 4px;
  margin: 0 auto;
  margin-top: 0.15rem;
  text-align: center;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
  font-size: 0.3rem;
}
</style>
